const Contenido1 = () => {
    return (
        <>
            <h1>Contenido 1</h1>
            <h3>Primer Apartado</h3>
        </>
    )
}

export default Contenido1